import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';

// utils
import { useUserRolePermissions } from 'hooks';

const CardHeaderSkeleton = () => {
  return (
    <Box display="flex" flexDirection="column" mb={0.5}>
      <Box height={28} width="100">
        <Skeleton height="100%" variant="rectangular" width="100%" />
      </Box>
      <Box height={20} mt={0.5} width="50%">
        <Skeleton height="100%" variant="rectangular" width="100%" />
      </Box>
    </Box>
  );
};

const CardBodySkeleton = () => {
  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" justifyContent="space-between">
        <Divider width="47%" />
        <Divider width="47%" />
      </Box>
      <Box display="flex" height={60} justifyContent="space-between" mb={2}>
        <Box alignItems="center" display="flex" flexDirection="column" pt="10px" width="47%">
          <Skeleton height="100%" variant="rectangular" width="100%" />
        </Box>
        <Box alignItems="center" display="flex" flexDirection="column" pt="10px" width="47%">
          <Skeleton height="100%" variant="rectangular" width="100%" />
        </Box>
      </Box>
      <Box display="flex" flexDirection="column">
        <Box height={61}>
          <Skeleton height="100%" variant="rectangular" width="100%" />
        </Box>
        <Box height={61} mt={2}>
          <Skeleton height="100%" variant="rectangular" width="100%" />
        </Box>
      </Box>
    </Box>
  );
};

const CardFooterSkeleton = () => {
  const { isProductLoadingManage } = useUserRolePermissions();

  return (
    <Box
      data-testid="skeleton"
      display="flex"
      flexDirection="row"
      justifyContent="space-around"
      mt={3}
    >
      {isProductLoadingManage && (
        <>
          <Box height={35}>
            <Skeleton
              height="100%"
              sx={{ borderRadius: '25px' }}
              variant="rectangular"
              width="100px"
            />
          </Box>
          <Box height={35}>
            <Skeleton
              height="100%"
              sx={{ borderRadius: '25px' }}
              variant="rectangular"
              width="100px"
            />
          </Box>
        </>
      )}
    </Box>
  );
};

const SupplierAuthCardSkeleton = () => {
  return (
    <Card
      sx={{
        height: 'auto',
        minHeight: 234,
      }}
      variant="loading"
    >
      <CardContent variant="loading">
        <CardHeaderSkeleton />
        <CardBodySkeleton />
        <CardFooterSkeleton />
      </CardContent>
    </Card>
  );
};

export default SupplierAuthCardSkeleton;
